"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function safeGet(fn) {
    try {
        return fn();
    }
    catch (e) {
        if (e instanceof TypeError) {
            return undefined;
        }
        throw e;
    }
}
exports.safeGet = safeGet;
//# sourceMappingURL=safe-get.js.map